import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import * as moment from 'moment';
import { Messages } from '../../shared/Validations/messages';
import { UploadToVault } from 'src/app/shared/common/uploadtovaultbutton';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import {CommonDownloadLinkFromS3} from '../../shared/common/commonDownloadLinkFromS3';
import { DatePipe } from '@angular/common';
import { RerunPopupComponent } from './rerun-popup/rerun-popup.component';
import { MatDialog } from '@angular/material/dialog';

import { VaultReference } from 'src/app/shared/common/vault-reference';
import { DownloadReportListHistoryS3ReportRef } from 'src/app/shared/common/DownloadReportListHistoryS3ReportRef ';
import { UserRoutingModule } from '../user-routing/user-routing.module';

@Component({
    selector: 'app-report-instance-history',
    templateUrl: './report-instance-history.component.html',
    styleUrls: ['./report-instance-history.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class ReportInstanceHistoryComponent implements OnInit {
  /**
   * @Description: Input property to receive screen path from parent component
   * when the component is called from another component.
   */
  @Input() screenPathFromParent: string | null = null;

  fromDate:Date
  toDate:Date
  includeSubReport:Boolean=false;

  value;
  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;
  buttonName;
  getdata: any;
  validation_messages:any;
  backgroundColorScreen = "";
  backgroundColorButton = "";

  presentDateTime: any;
  reportInstanceDetailsData: any = [];

  historyArray: any = [];
  skip=false;
  parenttemplateid;
   buttonIdList = []
  constructor(
    private datePipe: DatePipe,
    private snackBar: MatSnackBar,
    private constants: constants,
    private localStorageSettings: LocalStorageSettingsService,
    private commonService: CommonService,
    private msg: Messages,
    private router: Router,
    private spinner: NgxUiLoaderService,
    private reportlinksserviceService:ReportlinksserviceService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private userRoutingModule: UserRoutingModule,
    private selectedElement: ElementRef
  ) {
    this.components = {
      buttonRenderer: UploadToVault,
      downloadReportRef:DownloadReportListHistoryS3ReportRef,
      vaultReference: VaultReference
    }
    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;

    this.presentDateTime = moment().format(this.msg.DATEWITHTIMEFORMATFORCONVERSION);
    console.log(`upcoming screen present date : ${this.presentDateTime}`)
  }

  ngOnInit() {
    //  let screenPath = this.userRoutingModule.print(this.constructor.name);
      // const screenPath = this.router.url.replace(/^\//, '');
  let screenPath = '';
  /**
   * @Modified by: Rahul Kulkarni
   * @Date: 2024-06-12
   * @Description:  Below code modified to check if the component is called from parent component
   *                If yes, use the INPUT property 'screenPathFromParent'
   *                If not, extract screen path from current router URL(original Logic)
   */
  if (this.screenPathFromParent) {
    // Use the INPUT passed by parent component
    screenPath = this.screenPathFromParent;
    console.log("Using screenPath from parent:", screenPath);

  } else {
    // Fallback: extract from current router URL
    const fullPath = this.router.url;
    console.log('Full Path:', fullPath);

    const pathSegments = fullPath.split('/');
    screenPath = pathSegments[3];
    console.log('Screen Path:', screenPath);
    console.log(screenPath);
  }
    this.reportlinksserviceService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       console.log("Before querySelectorAll");
      /**
       * @Modified by: Rahul Kulkarni
       * @Date: 2024-06-12
       * @Description:  Below Selection of buttons From DOM : code modified 
       *                instead of selecting all buttons from the Entire DOM 
       *                Select only the DOM of the CURRENT component, using ElementRef(selectedElement);
       *                 
       */
       const buttons = this.selectedElement.nativeElement.querySelectorAll('button'); 
       console.log("Found buttons:", buttons.length);
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
       if (this.gridAPI) {
      this.gridAPI.refreshCells({ force: true });
    }
     });

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    this.columnDefs = [
      {
        headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          values: this.buttonIdList,
          uploadtovault:this.uploadtovault.bind(this),
          downloadcsv: this.downloadcsv.bind(this),
          redirecttoQuickSight: this.redirectQuickSight.bind(this),
        },
        pinned:'left',
        lockPinned: true,
        width: 200
      },

      // {
      //   headerName: 'Instance ID',
      //   headerTooltip: 'Instance ID',
      //   tooltipValueGetter: (params) => 'Instance ID: ' + params.value,
      //   field: 'instanceid',
      //   filter: 'agTextColumnFilter',
      //   width: 140
      // },
      // {
      //   headerName: 'Instance Detail ID',
      //   headerTooltip: 'Instance Detail ID',
      //   tooltipValueGetter: (params) => 'Instance Detail ID: ' + params.value,
      //   field: 'instancedetailid',
      //   filter: 'agTextColumnFilter',
      //   width: 120
      // },
      {
        headerName: 'Template Name',
        headerTooltip: 'Template Name',
        tooltipValueGetter: (params) => 'Template Name: ' + params.value,
        field: 'templatename',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Report Name',
        headerTooltip: 'Report Name',
        tooltipValueGetter: (params) => 'Report Name : ' + params.value,
        field: 'reportname',
        filter: 'agTextColumnFilter',
        width: 210
      },
      {
        headerName: 'Run Type',
        headerTooltip: 'Run Type',
        tooltipValueGetter: function(params) {
          if (params.value === null) {
            return 'Run Type : Scheduled';
          } else {
            return 'Run Type : ' + params.value;
          }
        },
        field: 'runType',
        filter: 'agTextColumnFilter',
        width: 210
      },
      
      // {
      //   headerName: 'Binder',
      //   headerTooltip: 'Binder',
      //   tooltipValueGetter: (params) => 'Binder : ' + params.value,
      //   field: 'binderId',
      //   filter: 'agTextColumnFilter',
      //   width: 210
      // },
      // {
      //   headerName: 'Binder Name',
      //   headerTooltip: 'Binder Name',
      //   tooltipValueGetter: (params) => 'Binder Name : ' + params.value,
      //   field: 'bindername',
      //   filter: 'agTextColumnFilter',
      //   width: 210
      // },
      // {
      //   headerName: 'Section Id',
      //   headerTooltip: 'Section Id',
      //   tooltipValueGetter: (params) => 'Section Id : ' + params.value,
      //   field: 'sectionid',
      //   filter: 'agTextColumnFilter',
      //   width: 210
      // },
      // {
      //   headerName: 'Section Name',
      //   headerTooltip: 'Section Name',
      //   tooltipValueGetter: (params) => 'Section Name : ' + params.value,
      //   field: 'sectionname',
      //   filter: 'agTextColumnFilter',
      //   width: 210
      // },
      {
        headerName: 'Scheduled Date & Time',
        headerTooltip: 'Scheduled Date & Time',
        tooltipValueGetter: (params) => 'Scheduled Date & Time : ' + params.value,
        field: 'scheduleddatetime',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Report Status',
        headerTooltip: 'Report Status',
        tooltipValueGetter: (params) => 'Report Status : ' + params.value,
        field: 'vaultuploadstatus',
        filter: 'agTextColumnFilter',
        width: 180
      },
      // {
      //   headerName: 'Status',
      //   headerTooltip: 'Status',
      //   tooltipValueGetter: (params) => 'Status : ' + params.value,
      //   field: 'status',
      //   filter: 'agTextColumnFilter',
      //   width: 120
      // },
      // {
      //   headerName: 'Download Report ',
      //   headerTooltip: 'Download Report ',
      //   tooltipValueGetter: (params) => 'Download Report : ' + params.value,
      //   field: 'reportpath',
      //   filter: 'agTextColumnFilter',
      //   width: 0
      // },
      {
        headerName: 'Report Reference',
        headerTooltip: 'Report Reference',
        cellRenderer: "downloadReportRef",
        field: 'reportpath',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'User ID',
        headerTooltip: 'User ID',
        tooltipValueGetter: (params) => 'User ID : ' + params.value,
        field: 'createdBy',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Vault Report Reference',
        headerTooltip: 'Vault Report Reference',
        cellRenderer: "vaultReference",
        field: 'vaultuploadstatus',
        filter: 'agTextColumnFilter',
        width: 180,
        valueGetter: () => 'Default Value'
      }, 
      
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) => 'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        width: 180
      },
      
    ]

    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
  }

  // sentToVault(senttoVault){
  //   this.reportlinksserviceService.insertToVault(senttoVault.reportInstanceDetailsId).subscribe(response=>{
  //       this.spinner.start();
  //       console.log(response);
  //       // checking if response is true or not
  //       if (response.error == true) {
  //         this.snackbar.open(response.statusMessage, "OK", {
  //           duration: 5000,
  //         });

  //       } else {

  //         console.log(response)
  //         this.snackbar.open(response.statusMessage, "OK", {
  //           duration: 5000,
  //         });

  //       }
  //       this.spinner.stop();
  //     });
  // }

  downloadcsv(e){
    console.log(e)
  }

  redirectQuickSight(e){
    console.log(e.rowData);
    if(e.rowData.reportpath == null){
      this.snackbar.open("Report generation is still in progress, Please try after some time", "OK", {
        duration: 5000,
      });
    }else{
    this.spinner.start();
    this.reportlinksserviceService.generateAnalysis( e.rowData.instancedetailid,this.localStorageSettings.getSettings("dnsName")).subscribe(result=>{
      this.snackbar.open(result.data, "OK", {
        duration: 5000,
      });
      this.spinner.stop();
      if(result.data ==="Analysis Generated"){
        const analysisReference = e.rowData.analysisreference;
        const url = this.router.serializeUrl(
          this.router.createUrlTree(['/user/Menubar/quickSight'], { queryParams: { analysis: analysisReference } })
        );
        window.open(url, '_blank');
        // this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
        //   this.router.navigate(["/user/Menubar/quickSight"],{queryParams:{analysis:e.rowData.analysisreference}})); 
        }
    });
  }
}

   //excel export function
   onBtExport() {
    this.gridAPI.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  // below function is to load the ag grid
  onGridReady(params) {
    let res: any
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.gridAPI.setGridOption('rowData', []);
    console.log(this.msg.screenName.REPORTINSTANCEDETAILSVIEW);
    const endDate = new Date();
    const todayDate=new Date();
    this.fromDate=this.convertLocalDateToUTC(todayDate);
    this.toDate=this.convertLocalDateToUTC(endDate);
    const formattedFromDate = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    const formattedToDate = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
    console.log(formattedFromDate,formattedToDate);
    this.reteriveAndInsertToGrid(formattedFromDate,formattedToDate,this.includeSubReport);

   
  }
  
  uploadtovault(event){
    console.log(event.rowData)
    var instancedetailid = event.rowData.instancedetailid;
    var instanceid = event.rowData.instanceid;
    var reportTemplateName = event.rowData.templatename
    console.log(instancedetailid);
    let dialogRef = this.dialog.open(RerunPopupComponent, {
      maxWidth: '100vw',
      height: "35%",
      width: "35%",
      data: {"instancedetailid":instancedetailid,"instanceid":instanceid}
    });
    this.spinner.start();
    // this.commonService.refreshReportsAndPushToVault(instancedetailid).subscribe((result =>{
    //   this.snackbar.open("Report rerun initiated", "OK", { duration: 5000 });
    // }));
    this.spinner.stop();
  }
  collectDates(){
    console.log(this.includeSubReport)
    if(!this.fromDate){
      this.snackBar.open(this.constants.selectFromDate, "OK", {duration: 5000});
    }
    else if (!this.toDate) {
      this.snackBar.open(this.constants.selectToDate, "OK", {duration: 5000});
    }
    else if(this.fromDate>this.toDate){
      this.snackBar.open(this.constants.toDateShouldBeGreator, "OK", {duration: 5000});
    }
    else{
    const formattedFromDate = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    const formattedToDate = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
    console.log(formattedFromDate,formattedToDate);
    this.reteriveAndInsertToGrid(formattedFromDate,formattedToDate,this.includeSubReport);
  }


}

reteriveAndInsertToGrid(formattedFromDate,formattedToDate,includeSubReport){
  this.commonService.retrieveRecordServiceWithRangeandCheckBox(this.msg.screenName.REPORTINSTANCEDETAILSVIEW,formattedFromDate,formattedToDate,includeSubReport).then((val) => {
    this.reportInstanceDetailsData = val;
   if(this.reportInstanceDetailsData.length==0){
    this.gridAPI.setGridOption('rowData', this.reportInstanceDetailsData);
     
    
  }this.historyArray=[];

    for(var i = 0; i < this.reportInstanceDetailsData.length; i++) {
      // let loopDateTime = moment(this.reportInstanceDetailsData[i].scheduleddatetime).format(this.msg.DATEWITHTIMEFORMATFORCONVERSION);
      // console.log(loopDateTime);
      // if(this.presentDateTime >= loopDateTime) {
      //   this.historyArray.push(this.reportInstanceDetailsData[i]);
      //   console.log(this.historyArray);
      //   this.gridAPI.setGridOption('rowData', this.historyArray);
      // }
      if(this.reportInstanceDetailsData[i].vaultuploadstatus ==="Sent to Vault" || this.reportInstanceDetailsData[i].vaultuploadstatus !=="Sent to Vault" ){
           this.historyArray.push(this.reportInstanceDetailsData[i]);
         
       // this.gridAPI.setGridOption('rowData', this.reportInstanceDetailsData);
      }
    }
    this.gridAPI.setGridOption('rowData', this.historyArray);
  });
}
convertLocalDateToUTC(localDate: Date): Date {
  const utcDate = new Date(
    localDate.getUTCFullYear(),
    localDate.getUTCMonth(),
    localDate.getUTCDate(),
    localDate.getUTCHours(),
    localDate.getUTCMinutes(),
    localDate.getUTCSeconds()
  );
  return utcDate;
}
}